module.exports = __webpack_public_path__ + "img/3.c9a440c3.png";